module.exports = __webpack_public_path__ + "graphics/close-button.ckh.db0dfad99c322c0fbecfe7d26482f792.svg";